import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import helpers from '../../../helpers/helpers';
import NotificationItem from '../../Cabinet/Profile/Notifications/NotificationItem';
import {onNotificationClick} from '../../Chat/chatHelpers';
import notificationsActions from '../../../store/actions/notificationsActions';
import Router from 'next/router';
import PROFILE from '../../../constants/profileConstants';
import styles from './HeaderNotifications.module.scss';
import IconChevronRight from '../../UI/Icons/IconChevronRight';

const HeaderNotifications = ({ closeDropdown }) => {
  const dispatch = useDispatch();
  const notifications = useSelector((state) => state.notifications.unreadNotificationsList);
  const { token } = useSelector((state) => state.auth);
  const { getTranslationText } = helpers;

  const readAllNotifications = () => {
    dispatch(notificationsActions.readAllNotifications(token));
  };

  const redirectAllNotifications = () => Router.push({ pathname: '/cabinet/profile', query: { page: PROFILE.NOTIFICATIONS }, shallow: true });

  return (
    <div className={styles.notifications}>
      <div className={styles.notificationsTitle}>{getTranslationText('header.notify')}: {notifications.length || 0}</div>
      <div className={styles.notificationsList}>
        {
          notifications.map((item) => (
            <NotificationItem
              key={item.id}
              title={item.text}
              date={item.created_at}
              replace={item.replace}
              onClick={() => onNotificationClick(item, dispatch, token)}
            />
          ))
        }
      </div>

      <div className={styles.notificationsFooter}>
        {/*<button*/}
        {/*  type="button"*/}
        {/*  onClick={() => readAllNotifications()}*/}
        {/*>*/}
        {/*  {getTranslationText('header.read_all_notif')}*/}
        {/*</button>*/}
        <button
          className={styles.notificationsLink}
          type="button"
          onClick={() => redirectAllNotifications()}
        >
          {getTranslationText('header.view_all_notif')}
          <IconChevronRight/>
        </button>
      </div>
    </div>
  );
};

export default HeaderNotifications;
